import { combineEpics } from "redux-observable";

import voidEpic from "./Payment.void.epic";
import refundEpic from "./Payment.refund.epic";
import getEpic from "./Payment.get.epic";
import preAuthEpic from "./Payment.modificationPreAuth.epic";
import openPaymentEpic from "./Payment.open.epic";
import receiptEpic from "./Payment.receipt.epic";

const epic = combineEpics(
  refundEpic,
  voidEpic,
  getEpic,
  preAuthEpic,
  openPaymentEpic,
  receiptEpic
);

export default epic;
